import cloneDeep from 'lodash.clonedeep';


// Generates Venue Data
export function generateVenueData(data) {
  return cloneDeep(data.venue);
}

// Generates Officials Data
export function generateOfficialsData(data) {
  return cloneDeep(data.officials);
}

// Generates Periods Data
export function generatePeriods(data) {
  return cloneDeep(data.periods);
}


// Generates Skater Data
export function generateSkaters(data) {
  const output = {};
  const skaters = cloneDeep(data.skaters);

  skaters.forEach(skater => {
    output[skater.id] = skater;
  })

  return output;
}

// Generates Goalie Data
export function generateGoalies(data) {
  const output = {};
  const goalies = cloneDeep(data.goalies);

  goalies.forEach(goalie => {
    output[goalie.id] = goalie;
  })

  return output;
}

// Generates Team Data
export function generateTeamData(data) {
  return {
    home: data.teams.home,
    visitor: data.teams.visitor,
    [data.teams.home]: cloneDeep(data.teams[data.teams.home]),
    [data.teams.visitor]: cloneDeep(data.teams[data.teams.visitor])
  }
}

// Generates Final Stats Data
export function generateFinalStats(data) {
  return {
    teams: {
      [data.teams.home]: {
        id: data.teams.home,
        ...cloneDeep(data.teams[data.teams.home].stats.final)
      },
      [data.teams.visitor]: {
        id: data.teams.visitor,
        ...cloneDeep(data.teams[data.teams.visitor].stats.final)
      },
    },
    skaters: data.skaters.map(skater => ({
      id: skater.id,
      team: skater.team,
      name: skater.name,
      position: skater.position,
      lines: cloneDeep(skater.lines),
      ...cloneDeep(skater.stats.final),
    })),
    goalies: data.goalies.map(skater => ({
      id: skater.id,
      team: skater.team,
      name: skater.name,
      position: skater.position,
      lines: cloneDeep(skater.lines),
      ...cloneDeep(skater.stats.final),
    }))
  }
}

export function generateInitalLiveData(data) {
  // Live Stats
  const stats = generateLiveStats(data);

  // Period
  const period = data.periods['1stPeriod'];

  return {
    clock: {
      elapsed: 0,
      total: period.length,
      penalties: {
        [data.teams.home]: [],
        [data.teams.visitor]: [],
      }
    },
    goals: { [period.key]: [] },
    inGoal: {
      [data.teams.home]: data.goalies.find(goalie => (goalie.team === data.teams.home) && goalie.lines.includes('G1')).id,
      [data.teams.visitor]: data.goalies.find(goalie => (goalie.team === data.teams.visitor) && goalie.lines.includes('G1')).id,
    },
    notes: [],
    pastEvents: [],
    remainingEvents: cloneDeep(data.events),
    shootout: {
      isActive: false,
      [data.teams.home]: [
        { id: 'attempt-1', player: '', result: 'pending' },
        { id: 'attempt-2', player: '', result: 'pending' },
        { id: 'attempt-3', player: '', result: 'pending' }
      ],
      [data.teams.visitor]: [
        { id: 'attempt-1', player: '', result: 'pending' },
        { id: 'attempt-2', player: '', result: 'pending' },
        { id: 'attempt-3', player: '', result: 'pending' }
      ]
    },
    stats,
    penalties: { [period.key]: [] },
    period,
  }
}


// Generates Live Stats Data
function generateLiveStats(data) {
  return {
    teams: {
      [data.teams.home]: {
        id: data.teams.home,
        ...cloneDeep(data.teams[data.teams.home].stats.live)
      },
      [data.teams.visitor]: {
        id: data.teams.visitor,
        ...cloneDeep(data.teams[data.teams.visitor].stats.live)
      },
    },
    skaters: data.skaters.map(skater => ({
      id: skater.id,
      team: skater.team,
      name: skater.name,
      position: skater.position,
      lines: cloneDeep(skater.lines),
      ...cloneDeep(skater.stats.live),
    })),
    goalies: data.goalies.map(skater => ({
      id: skater.id,
      team: skater.team,
      name: skater.name,
      position: skater.position,
      lines: cloneDeep(skater.lines),
      isHidden: !skater.lines.includes('G1'),
      ...cloneDeep(skater.stats.live),
    }))
  }
}


export default {
  generateInitalLiveData,
  generateFinalStats,
  generateTeamData,
  generatePeriods,
  generateOfficialsData,
  generateVenueData
}